export default function TaxHarvestingConsultHeader({dateStart, dateEnd, clientName, accountId}) {
  return (
    <div className="c-tax-harvesting-results__header">
      <h2 className="c-tax-harvesting-results__title">Resultados de la consulta</h2>
      <p className="c-tax-harvesting-results__summary">
        {dateStart} → {dateEnd} · {clientName} · {accountId}
      </p>
    </div>
  )
}
